// extracted by mini-css-extract-plugin
module.exports = {"loader":"_3USU7","load6-ltr":"_3QUbk","load6Ltr":"_3QUbk","load6-rtl":"_1ifGI","load6Rtl":"_1ifGI","medium":"_3wHC6","mini":"_3CPnV"};